<!--
 * @Description: 项目结算管理
 * @Date: 2020年11月13日11:19:23
-->
<template>
  <div style="height:100%;">
    <table-render
      class="custom-table"
      ref="tableRender"
      height="calc(100vh - 200px)"
      rowKey="id"
      v-if="config"
      :config="config"
      :propData="propData"
    />
    <!-- 添加v-if防止组件内额外请求 ??? -->
    <order-create
      v-model="dialogVisible.create"
      v-if="dialogVisible.create"
      @createdOrder="createdOrder"
    />
  </div>
</template>

<script>
import tableRender from '@/components/tableRender';
import { main } from './config/index.js';
import orderCreate from './child/orderCreate/index.vue';
import { mapGetters } from 'vuex';
import { deepClone } from '@/tools';
import { existsBusService } from '@/api/ajax';

export default {
  name: 'orderMgmt',
  cname: '项目结算管理',
  components: {
    tableRender,
    orderCreate
  },
  computed: {
    ...mapGetters(['hasPayRule'])
  },
  data() {
    return {
      config: null,
      payProgress: '',
      dialogVisible: {
        create: false
      },
      currentRow: '',
      propData: {}
    };
  },
  methods: {
    toggleActionsVisible(actionName) {
      try {
        this.dialogVisible[actionName] = true;
      } catch (err) {
        console.error(err);
      }
    },
    // 创建完成订单，刷新列表
    createdOrder() {
      this.$refs.tableRender.init();
    }
  },
  async created() {
    this.propData.footer =
      '<div style="margin-top:24px;color:rgb(204, 51, 51)">由于每个自然月“供应商服务费率”有可能会有调整，故所有未生成订单内的“供应商服务费率”以及“结算总价”仅当月有效。</div>';
    this.propData.showFooter = true;
    const dMain = deepClone(main);
    const { projectId, projectName } = this.$route.query;
    const {
      pdata: { existsCount }
    } = await existsBusService({ t: Date.now() });
    const defaultQuery = projectId
      ? {
          // 项目名称默认值
          select_projectId: {
            projectName,
            projectId: +projectId
          },
          // 列表默认参数
          projectId
        }
      : {};
    dMain.forEach(item => {
      Object.assign(item.childMenu[0].defaultQuery, defaultQuery);
      // 无权限
      if (!this.hasPayRule) {
        item.childMenu[0].moreBtnArr = [];
      }
    });
    const removeFields = (target, list) => {
      list.forEach(removeProp => {
        target.fields.splice(
          target.fields.findIndex(item => item.prop === removeProp),
          1
        );
      });
    };
    const removeSearchItem = (target, list) => {
      list.forEach(removeProp => {
        target.search.splice(
          target.search.findIndex(item => item.key === removeProp),
          1
        );
      });
    };
    if (existsCount <= 0) {
      dMain.forEach((item, index) => {
        //无商务服务费删除商务服务费字段
        removeFields(dMain[index]['childMenu'][0], ['bussniessServicesStatus']);
        removeSearchItem(dMain[index]['childMenu'][0], [
          'bussniessServicesStatus'
        ]);
      });
    }
    this.config = dMain;
  }
};
</script>
<style lang="scss">
.ellipsis {
  max-width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 8px;
}
.batch-actions {
  &__count {
    display: block;
    min-width: 100px;
    height: 30px;
  }

  &__btngroup {
    margin-right: 20px;
  }

  &__btn {
    margin: 0 10px;
    cursor: pointer;
    color: #46a6ff;
    text-underline: #46a6ff;
    user-select: none;

    &:active {
      opacity: 0.8;
    }
  }

  &__info {
    width: max-content;
    height: 30px;
    line-height: 30px;
    background: #e6f1fc;
    min-width: 400px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    border-radius: 3px;

    &__mark {
      color: #46a6ff;
      font-size: 16px;
      padding: 0 5px;
    }
    &__icon {
      &:hover {
        color: #46a6ff;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.custom-table {
  ::v-deep {
    & > div {
      height: 100%;
    }
  }
}
</style>
